module.exports = __webpack_public_path__ + "2f085ecf7bd338695b97b77d10e8a637.png";